// extracted by mini-css-extract-plugin
module.exports = {"text-wrapper":"text-wrapper--3Q1yIwOK"};